import Loadable from '../../components/loadable';

const ChangelogList = Loadable({
  loader: () => import('../../pages/changelog/list'),
  type: 'block',
});

angular.module('gym').value('ChangelogList', ChangelogList);

const ChangelogItem = Loadable({
  loader: () => import('../../pages/changelog/item'),
  type: 'block',
});

angular.module('gym').value('ChangelogItem', ChangelogItem);
